import { createApp } from 'vue';
import removeHostBtn from '../../components/viewed-hosts/remove-host-btn.vue';

document.addEventListener('DOMContentLoaded', () => {
	let templates = document.querySelectorAll("[data-vue='remove-host-btn']");
	for (let el of templates) {
		const initialData = JSON.parse(el.getAttribute('data'));
		const app = createApp(removeHostBtn, { userId: initialData['userId'] });
		app.mount(el);
	}
});
